

import { crearProductoBom } from '../infraestructure/supabase/productosBom.repository.js'

export async function crearProductoBomUseCase(data) {
 // Validaciones correctas
  if (!data?.producto_linea) {
    throw new Error('[crearProductoBomUseCase] PRODUCTO_LINEA_REQUIRED')
  }

  if (!data?.producto_insumo) {
    throw new Error('[crearProductoBomUseCase] PRODUCTO_INSUMO_REQUIRED')
  }

  if (!data?.cantidad || data.cantidad <= 0) {
    throw new Error('[crearProductoBomUseCase] CANTIDAD_INVALIDA')
  }

  // Insertar BOM
  const bomCreado = await crearProductoBom({
    producto_linea: data.producto_linea,
    producto_insumo: data.producto_insumo,
    cantidad: data.cantidad,
    unidad: data.unidad || 'UND',
    created_by: data.usuario || 'user default',
  })

  if (!bomCreado) {
    throw new Error('[crearProductoBom]No se pudo crear el BOM')
  }

  console.log('[crearProductoBom] BOM success:', bomCreado)

  return bomCreado
}